var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.effectiveTag,
    _vm._g(
      {
        tag: "component",
        class: _vm.classes,
        attrs: {
          type: _vm.effectiveType,
          disabled: _vm.isNativeButton && !_vm.enabled,
          to: _vm.to,
          role: _vm.effectiveRole,
          tabindex: _vm.effectiveTabIndex,
          "aria-disabled": _vm.effectiveAriaDisabled,
          "aria-label": _vm.ariaLabel,
        },
      },
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }